import { useQuery } from 'react-query';

import { getTopDurationOverrunRisk as queryFn } from 'api/endPoints/getTopDurationOverrunRisk';

export const useQueryTopDurations = (params) => {
    return useQuery(['topDurations', params], () => queryFn(params), {
        enabled: params.id.length > 0,
    });
};
